import { SET_PROVIDER, TSetProvider } from '~/src/store/reducers/city';

export const setProviderId = (providerId: number): TSetProvider => ({
    type: SET_PROVIDER,
    payload: {
        provider: { providerId },
    },
});
